/**
 * Detect whether the current browser is running on a mobile device.
 *
 * Uses user-agent heuristics (same as Gmail's approach).
 * Does NOT consider tablets as mobile — they get the full desktop web experience.
 */
export const isMobileBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';

  // Standard mobile tokens (excludes iPad which sends desktop UA by default)
  return /Android.*Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile Safari/i.test(ua);
};
